import React from "react";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";

type Props = React.ComponentProps<typeof Button>;

const AddIconButton: React.FC<Props> = (props) => {
  return (
    <Button
      {...props}
      size="small"
      startIcon={<AddRoundedIcon fontSize="small" />}
    >
      Add
    </Button>
  );
};

export default AddIconButton;
